import cn from "classnames";
import styles from "./styles.module.scss";
import Title from "@/ui/Title";
import Image from "@/ui/Image";
import Search from "@/assets/Search.svg";
import { useRouter } from "next/router";

export const HeroBanner = ({ title, image, subtitle, content, showJobSearch = false }) => {
  const router = useRouter();

  const searchJob = () => {
    const inputValue = document.getElementById("hero-banner-input").value;
    router.push({
      pathname: "/jobs",
      query: { query: inputValue },
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      searchJob();
    }
  };

  return (
    <section className={cn(styles.hero)}>
      <Image
        img={`${image?.url ? image?.url : "/images/placeholders/placeholder-image.jpeg"}`}
        size="1440x500"
        className={cn(styles.bg_image)}
        alt={image?.alt ? image?.alt : "s"}
      />
      {subtitle && <Title title={subtitle} tag="div" className={cn(styles.subtitle, "h5")} />}
      {title && <Title title={title} tag="h1" className={cn(styles.title)} />}
      {content && <Title title={content} tag="div" className={cn(styles.text, "p")} />}

      {showJobSearch && (
        <div className={styles.search_wrapper}>
          <div className={styles.search}>
            <input
              id="hero-banner-input"
              placeholder={`Type to search from 124 jobs`}
              className={styles.input}
              onKeyDown={handleKeyDown}
            />
            <div className={styles.iconCont} onClick={searchJob}>
              <Search className={styles.icon} />
            </div>
          </div>

          <div className={styles.arrow_nav}>
            <button className={styles.arrow_btn} aria-label="Previous">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.0882 19.7841C13.2862 19.5381 13.2442 19.1803 12.9935 18.9855L11.2228 17.6086L8.8967 15.5665L23.4223 15.5665C23.7416 15.5665 24 15.3119 24 14.998C24 14.6842 23.7416 14.4295 23.4223 14.4295L9.04188 14.4295L13.0775 10.9984C13.3185 10.7938 13.3459 10.4345 13.1372 10.1968C12.9284 9.9592 12.5637 9.93305 12.3223 10.1385L7.0574 14.6149C6.93147 14.7217 6.85868 14.8768 6.85714 15.0405C6.85714 15.042 6.85714 15.0435 6.85714 15.045C6.85714 15.2073 6.92724 15.3615 7.05009 15.4691L10.4799 18.4788L12.2768 19.8773C12.5271 20.0721 12.8903 20.0304 13.0882 19.7841Z"
                  fill="white"
                />
              </svg>
            </button>
            <button className={styles.arrow_btn} aria-label="Next">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.9117 10.2159C16.7138 10.4619 16.7558 10.8197 17.0065 11.0145L18.7772 12.3914L21.1033 14.4335L6.57767 14.4335C6.25841 14.4335 6 14.6881 6 15.002C6 15.3158 6.25841 15.5705 6.57767 15.5705L20.9581 15.5705L16.9225 19.0016C16.6815 19.2062 16.6541 19.5655 16.8628 19.8032C17.0716 20.0408 17.4363 20.0669 17.6777 19.8615L22.9426 15.3851C23.0685 15.2782 23.1413 15.1232 23.1429 14.9595C23.1429 14.958 23.1429 14.9565 23.1429 14.955C23.1429 14.7927 23.0728 14.6385 22.9499 14.5309L19.5201 11.5212L17.7232 10.1227C17.4729 9.92786 17.1097 9.96956 16.9117 10.2159Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default HeroBanner;
